// Replace the default import with named import
import { createClient } from '@sanity/client';

// Define your client configuration with API version
const client = createClient({
  projectId: 'i6xx6szr', 
  dataset: 'production',  
  apiVersion: '2023-07-07',  
  useCdn: true,  
});

export { client };
